import { api, config } from '../../../helpers/api';

export async function feedbacksListRequest(lastId, involveWith) {
  return await api.get(
    '/feedback_request/',
    config('json', {
      last_id: lastId,
      involve_with: involveWith
    })
  );
}
